export default {
  locale: 'zh-CN',
  language: '简体中文',
  page: {
    title: 'tv.SOGA商城',
    error: {
      title: '对不起，出错了！'
    },
    home: {
      title: '首页',
      description: 'tvSOGA推出会员专属商城『搜咖购物』，将会提供给会员们物美价廉的各式商品，甜甜价只有会员独享，立即加入tvSOGA这个大家族，享受购物乐趣!!',
      keywords: 'tv.SOGA商城,搜咖购物'
    },
    reg: {
      title: '会员注册',
      pwd: '设定密码：',
      pwd_confirm: '确认密码：',
      mobile_code: '短信验证码：',
      btn_reg: '注册',
      btn_login: '会员登录',
      ph_pwd: '6-15位字母或数字',
      ph_pwd_confirm: '再次输入设定密码',
      diff_pwd: '两次密码输入不一致！',

      verify_code: '输入校验码',
      invalid_code: '校验码不正确！',
      btn_code: '获取验证码',
      invalid_sms: '短信验证码不正确！',

      label_agree: '已阅读并同意',
      label_privacy: '隐私权保护宣告',
      tip_privacy: '需要同意隐私权保护宣告！',
      btn_agree: '同意',
      btn_disagree: '不同意',

      alert_reg: '为维护您的权益，会员注册将会立即开通tv.SOGA电视专属浏览器的5天试用期。',
      btn_continue: '继续注册',
      btn_othertime: '稍后注册',
      tip_reg: '加入会员立即开通tv.SOGA电视专属浏览器5天试用！',
      register_ok: '欢迎您加入tv.SOGA！',
      register_fail: '注册失败！'
    },
    login: {
      title: '会员登录',
      forgot: '忘记密码?',
      state_code: '国际区号：',
      mobile: '手机号码：',
      pwd: '密  码',
      btn_login: '登录',
      btn_reg: '注册成为会员',
      ph_statecode: '请选择区号！',
      ph_mobile: '请填写手机号码！',
      ph_pwd: '请输入密码！',
      tip_invalid_pwd: '密码无效！',

      quick_opt: '操作过于频繁！',
      login_ok: '欢迎您再次回来！',
      login_fail: '登录失败！'
    },
    resetpwd: {
      title: '重置密码',
      btn_reset: '重置密码',
      btn_login: '会员登录',

      reset_ok: '密码重置成功！'
    },
    member: {
      title: '会员专区',
      mobile: '手机号码：',
      nick: '昵称：',
      sex: '性别：',
      sex_male: '男',
      sex_female: '女',

      location: '位置：',
      btn_location: '更改地区',
      loading_location: '正在获取...',

      birth: '生日：',

      btn_pwd: '修改密码',
      old_pwd: '旧密码：',
      new_pwd: '新密码：',
      cfm_pwd: '确认密码：',
      ph_old_pwd: '请输入旧密码',
      ph_new_pwd: '6-15位字母或数字',
      ph_cfm_pwd: '再次输入设定密码',
      diff_pwd: '两次密码输入不一致！',
      invalid_pwd: '新密码无效！',

      ph_unset: '未设定',
      btn_birth: '请选择',
      btn_sn_add: '添加序号',
      btn_sn_view: '查看所有序号/共{n}组',
      btn_sn_buy: '序号购买',

      label_device: '设备：',
      no_device: '未知',
      label_bind_time: '绑定时间：',
      label_expires: '过期时间：',
      label_no_bind: '尚未绑定！',

      tip_modify_ok: '修改成功！',
      btn_modify: '保存修改'
    },
    jump: {
      title: '跳转',
      tip: '您将在{n}秒后跳转至',
      wait: '请耐心等候...',
      no_jump: '若无自动跳转，请点击',
      to_official: '若想了解tv.SOGA，请至',
      index: '首页',
      official: '官方网站'
    },
    addr: {
      title: '地址管理',
      no_address: '还没有收货地址，赶紧去添加吧！',
      btn_new: '新建收货地址'
    },
    goods_group: {
      title: '商品分类',
      label_search: '搜索：'
    },
    goods_detail: {
      title: '商品详情',
      label_des: '产品介绍',
      label_delivery: '运送方式',
      label_notice: '注意事项',
      label_refund: '退换货规定'
    },
    cart: {
      title: '购物车',
      tip_no_items: '购物车空空如也，快去添加商品吧！'
    },
    order_manage: {
      title: '订单管理',
      no_order: '尚无订单！',
      label_status: '状态：',
      all_status: '全部',
      label_sort: '排序：',
      sort_values: [
        '日期新到旧',
        '日期旧到新',
        '金额多到少',
        '金额少到多'
      ]
    },
    order_add: {
      title: '商品订购',

      buy_num: '购买数量',
      bind_type: '绑定方式',
      bind_no: '序号不绑定任何帐户',
      bind_yes: '序号绑定当前帐户',

      btn_order_add: '提交订单',

      title_addr: '请选择收货地址',
      tip_invalid_addr: '请填写配送地址',

      tip_pay_confirm: '请确认收件资料填写正确，后续寄件将以填写资料为主。',
      btn_pay_confirm: '确认支付',
      use_discount: '使用折扣码',
      discount_code: '折扣码',
      discount_amount: '折扣金额',
      not_use_discount: '不使用',
      use_coin: '碳币抵扣',
      max_use_coin: '最多可使用<span>{n}</span>个碳币',
      use: '使用',
      no_use: '不使用',
      input_coin_tip: '请选择要抵扣的碳币数量'
    },
    order_pay: {
      title: '订单支付',
      label_pay_amount: '合计支付'
    },
    order_detail: {
      title: '订单信息',
      btn_rebuy: '再次购买',
      btn_refund: '退货申请',
      btn_complete: '完成订单',

      label_remark: '备注',
      btn_remark: '发送',
      service_name: 'tvSoga小精灵'
    },
    order_refund: {
      title: '退货申请',
      refund_info: '退货资料填写',
      btn_request: '申请',
      ph_select: '请选择',
      ph_input: '请输入',

      ph_bank_user: '银行户名',
      ph_bank_code: '银行代码',
      ph_bank_name: '银行名称',
      ph_bank_account: '银行帐号',

      title_addr: '退货地址编辑',

      jump_msg: '已收到您的退货申请'
    }
  },
  menu: {
    tip_login: '请登录！',

    group_title_note: '购物说明',
    item_label_about: '关于我们',
    item_label_notice: '购物须知',
    item_label_qa: '常见问题',
    item_label_privacy: '隐私权保护宣告',

    btn_official: '官方',

    order_query: '订单查询',
    member_area: '会员专区',
    member_addr: '地址管理',
    register_login: '会员登录/注册',
    logout: '登出',
    delete_account: '删除帐号',

    tip_logout: '已登出！'
  },
  user: {
    btn_login: '会员登录',
    del_tip_title: '警告：删除用户数据操作不可逆！请谨慎操作！',
    del_tip_logout: '请先登陆用户再进行删除操作！',
    del_tip_content_1: '<p style="font-size: 1.2rem;">您正在删除用户 [<span style="color:blue">{username}</span>] 的所有数据。</p>',
    del_tip_content:
      [
        '删除用户数据后，该用户的所有信息将被永久删除，包括订单、收货地址、个人资料等。',
        '是否确认删除用户数据？'
      ],
    btn_del: '确认删除',
    btn_cancel: '取消操作',
    del_ok: '帐号删除成功！',
    del_ok_content: '该用户的所有信息将被永久删除，包括订单、收货地址、个人资料等。',
    del_fail: '删除失败！',
    del_fail_content: '删除用户数据失败，请稍后再试。',
    del_confirm: '请输入登录密码以授权删除用户数据！'
  },
  goods: {
    group_all: '全部商品',
    group: '商品分类',
    tip_no_items: '没有任何商品！',
    tip_no_exist: '商品不存在或已经下架！',
    name: '商品名',
    price: '单价',
    tip_sellout: '缺货',
    tip_not_enough: '库存不足！',
    alert_not_enough: '{name} 库存不足！',
    label_stock: '库存',
    discount: '{n}折',

    ph_qrcode: '正在生成二维码！',
    tip_qrcode_fail: '二维码获取错误！',

    label_original: '原价',
    label_promotion: '活动价'
  },
  order: {
    status: {
      0: '错误订单',
      1: '等待买家付款',
      2: '买家已付款',
      3: '卖家已发货',
      4: '买家已签收',
      5: '已评价',
      10: '交易完成',
      97: '支付确认中',
      98: '支付失败',
      99: '交易关闭'
    },
    err_status: '状态异常',
    no_order: '订单不存在',

    order_no: '订单编号：',
    buy_num: '数量',

    total_amount: '订单小计',
    promotion_amount: '优惠金额',
    discount_amount: '折扣金额',
    pay_amount: '订单金额',
    freight_amount: '运费金额',
    freight_discount: '运费折扣',

    weight: '重量',

    receive_info: '收件人信息',
    label_receive_name: '联系人：',
    label_receive_tel: '联系电话：',
    label_transport_way: '寄送方式：',
    label_receive_addr: '寄送地址：',
    label_delivery_no: '快递单号：',

    transport_way: '配送方式',
    way_logistics: '物流配送',
    transport_addr: '配送地址',

    transport_info: '配送信息',
    area_not_support: '所在地区不支持！',

    startup_sn: '启动序号',
    bind_sn: '绑定用户：',
    label_time: '订单时间',
    add_time: '下单时间',
    pay_time: '付款时间',
    complete_time: '交易成功时间',

    refund_info: '退货信息',
    label_refund_reason: '退货原因：',
    label_refund_user: '订购人姓名：',
    label_refund_addr: '退货收件地址：',
    label_refund_tel: '联系电话：',
    label_refund_account: '退款银行帐号',

    refund_refuse_reason: '婉拒退货原因',

    refund_time: '退货时间',
    label_refund_time_request: '申请时间：',
    label_refund_time_accept: '接收退货时间：',
    label_refund_time_refuse: '拒绝退货时间：',

    label_complete_order: '※收到商品后请点选“完成订单”，若未点选，系统于7天后自动完成订单，若未收到商品，请与我们联系。'
  },
  footer_info_html: '客服邮箱：tvsoga@gmail.com<br>' +
    '服务时间：周一至周五 09:00AM-06:00PM<br>' +
    '（午休时间：PM12:30-PM01:30）<br>' +
    '（公休日：周六与周日）',
  addr: {
    title: '收货地址编辑',
    title_new: '新建收货地址',
    label_user: '联系人：',
    ph_user: '联系人姓名',
    label_tel: '手机号码：',
    ph_tel: '通过此号码联系',
    label_area: '所在地区：',
    ph_area_sel: '请选择...',

    title_area: '请选择所在区域',
    ph_area_first: '国家或地区',

    label_address: '详细地址：',
    ph_address: '街道、楼牌号等',
    label_addr_def: '设置预设地址：',
    value_def: '预设',

    tip_invalid_name: '请填写联系人！',
    tip_invalid_tel: '手机号码不正确！',
    tip_invalid_state_code: '手机区号不正确！',
    tip_invalid_area: '请选择收货区域！',
    tip_invalid_addr: '请填写详细地址！',
    postcode: '邮政编码'
  },
  invoice: {
    title: '发票资讯',
    personal_invoice: '个人发票',
    company_invoice: '公司发票',
    tax_id: '统一编号',
    invoice_head: '发票抬头',
    tax_id_tip: '请输入发票编码',
    invoice_head_tip: '请输入发票抬头',
    personal_tip: '<p>信用卡结账（台湾用户）：</p>\n' +
      '      <p>发票会开立于银行端留存之台湾手机门号的短信内。</p>\n' +
      '      <p></p>\n' +
      '      <p>信用卡结账（海外用户及ATM结账用户）：</p>\n' +
      '      <p>将开立二联式发票，如需索取正本请自行负担运费。</p>',
    invoice_tip: '※依统一发票使用办法规定：个人发票一经开立，无法更改或改开公司户发票，需开立统编请选择『公司发票』，一经开立不得要求更改。',
    invoice_tip2: '※依统一发票使用办法规定：公司户发票一经开立，无法更改为个人发票。请务必确认输入之公司统编是否正确，一经开立不得要求更改。',
    history_invoice: '历史开票信息',
    add_invoice: '新增开票信息',
    tax_id_tip2: '统一编号不正确'
  },
  common: {
    alert_title: '温馨提示',
    logining: '正在登录...',
    delete_confirm: '确定删除？',
    btn_ok: '确定',
    btn_cancel: '取消',
    btn_back: '返回',
    btn_save: '保存',
    btn_del: '删除',
    btn_next: '下一步',

    btn_buy: '立即购买',
    btn_pay: '支付',

    tip_loading: '正在加载...',
    tip_refresh: '刷新中...',
    tip_loadmore: '加载中...',

    err_param: '参数错误',
    err_server: '若您持續遇到此問題，請聯絡<a href="https://lin.ee/sFVGdO6" target="_blank">Line@客服</a>支援以獲得協助。<br/>\n'
  },
  error: {
    400: '请求错误',
    401: '未授权，请登录',
    403: '拒绝访问',
    404: '请求错误',
    408: '请求超时',
    500: '服务器内部错误',
    501: '服务器内部错误',
    502: '网关错误',
    503: '服务不可用',
    504: '网关超时',
    505: 'HTTP版本不受支持',

    1000000: '获取数据失败！',
    1010000: '未登录！',
    1011000: '令牌失效！',
    1012000: '无权访问！',

    // 1020000: '参数错误！',
    1020003: '密码格式不正确！',
    1020004: '帐号未注册！',
    1020005: '密码错误！',

    1020014: '验证码错误！',
    1020015: '邮箱地址错误！',
    1020022: 'SN碼错误！',
    1020023: 'SN已經被使用！',
    1020024: '没有绑定SN！',
    1020025: '授权過期！',

    1021000: '文件上传错误！',
    1021002: '文件不存在！',

    // 1100000: '服务器异常，请重试！',
    1100001: '操作超时！',

    1200000: '服务器维护中！'
  }
}
